export default "<i class=\"material-icons\" role=\"img\"\r\n    [tooltip]=\"content\" placement=\"auto\">help_outline</i>\r\n";